module.exports = __webpack_public_path__ + "img/05.c0d6b79d.jpg";